export default __webpack_public_path__ + "static/media/Elena_Olusola_Giorgia_Ikumapayi.a8a452ba.png";